import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Prompt } from 'react-router'

import { withFirebase } from 'services/firebase';
import { setConversations } from 'redux/conversations';

import Chat from 'components/Chat';

class ChatContainer extends React.Component {
  componentWillMount = async () => {
    const { companyId } = await this.props.firebase.userData();
    if (!companyId) return;

    this.props.firebase.conversations({ companyId }).on('value', snapshot => {
      const data = snapshot.val();
      if (!data) return;

      const conversations = Object.keys(data)
        .map(id => ({ id, ...data[id] }))
        .filter(conversation => conversation.archived !== true)
        .sort((a, b) => b.created_at - a.created_at);

      this.props.setConversations(conversations);
      this._refreshInterval = setInterval(() => this.forceUpdate(), 30000);
    });
  }

  componentWillUnmount = () => {
    clearInterval(this._refreshInterval);
  }

  render() {
    return (
      <React.Fragment>
        <Chat />

        <Prompt
          when={this.props.onCall}
          message="Leaving page will end the call. Are you sure you want to leave this page?"
        />
      </React.Fragment>
    );
  }
}

export default compose(
  withFirebase,
  connect(
    state => ({
      onCall: state.conversations.onCall,
    }),
    { setConversations }
  ),
)(ChatContainer);

